import { siteUrl } from '../EnvUtils';
/**
 * Origin - required for mocking window.location.origin in unit tests
 */
const Origin = window.location.origin;
/**
 * Url path name
 */
const PathName = window.location.pathname;
const isRelativePath = (url) => url.charAt(0) === "/" || (url.substring(0, 2) === "./") || (url.substring(0, 3) === "../");
const removeSubdomain = (domain) => {
    let urlSubdomains = domain.replace(/[^.]/g, "").length;
    //remove subdomains while they are still present in either url
    while (urlSubdomains > 1) {
        const first = domain.split('.')[0];
        domain = domain.replace(first, ""); //remove domain name
        domain = domain.substring(1); //remove '.'
        urlSubdomains--; //dec for loop
    }
    return domain;
};
const gettopdomain = () => {
    const regex = /^(?:https?:\/\/)?(?:[^@/\n]+@)?(?:www\.)?([^:/?\n]+)/;
    const host = regex.exec(window.location.host);
    let domain = '';
    if (host) {
        if (host[1][host[1].length - 1] === ".") {
            host[1] = host[1].substring(0, host[1].length - 1);
        }
        domain = removeSubdomain(host[1]);
    }
    return domain;
};
/**
 * @param url
 */
function isExternal(url) {
    const regex = /^(?:https?:\/\/)?(?:[^@/\n]+@)?(?:www\.)?([^:/?\n]+)/;
    try {
        //check for same-path traversal
        if (isRelativePath(url)) {
            return false;
        }
        //initial 'easy' parse
        const host = regex.exec(window.location.host);
        let domain = regex.exec(url);
        //check for protocol-relative url, remove slashes and rerun regex
        if (url.substring(0, 2) === "//") {
            url = url.replace("//", "");
            domain = regex.exec(url);
        }
        if (domain && host) {
            if (domain[1][domain[1].length - 1] === ".") {
                domain[1] = domain[1].substring(0, domain[1].length - 1);
            }
            if (host[1][host[1].length - 1] === ".") {
                host[1] = host[1].substring(0, host[1].length - 1);
            }
            domain[1] = removeSubdomain(domain[1]);
            host[1] = removeSubdomain(host[1]);
            //compare domains
            return (host[1] !== domain[1]);
        }
    }
    catch (ex) {
        console.log(ex);
    }
    //unrecognized url, assume external
    return true;
}
function getQueryParameterByName(name, url = window.location.href) {
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
function getSurveyUrl(surveyUrl, isLoggedIn, chatId, jsSessionId) {
    const chatType = isLoggedIn ? "postlogin" : "prelogin";
    return getCompleteSurveyUrl(surveyUrl, `?chattype=${chatType}&chatid=${chatId}&icon=sync1&turl=${siteUrl}/Conversationhistory.html?JsSessionId=${jsSessionId}&parent=${siteUrl}/`);
}
function getCompleteSurveyUrl(surveyUrl, queryParameters) {
    return `${surveyUrl}${queryParameters}`;
}
export { isExternal, Origin, PathName, getQueryParameterByName, getSurveyUrl, getCompleteSurveyUrl, gettopdomain };
